module.exports = __webpack_public_path__ + "static/media/6.4_preview.26085dc4.png";